import React from "react";
import "./index.scss";

const Dots = () => {
  return <div className="dots">. &nbsp;. &nbsp;.</div>;
};

export default Dots;
